import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { useNavigate } from "react-router-dom";


const ProyectosAdmin = () => {
  const navigate = useNavigate();
  const [filtro, setFiltro] = useState("Todos");
  const [contenido, setContenido] = useState(false);
  const [titulo, setTitulo] = useState("");
  const [descripcion, setDescripcion] = useState("");
  const [imagen, setImagen] = useState("");
  const [file, setFile] = useState(null);
  const [datos, setDatos] = useState([]);
  const [modalData, setModalData] = useState(null); // Estado para almacenar la imagen activa
 const [inputDescripcion, SetInpuntDescripcion] = useState("")
 const [inputTitulo, SetInpuntTitulo] = useState("")
 const [inputImagen, SetInpuntImagen] = useState(null)


 useEffect(() => {
  fetch("https://disomex.onrender.com/api/verificar-sesion", {
    method: "GET",
    credentials: "include", // 🔥 Esto es clave para que las cookies se envíen en la petición
  })
    .then(response => response.json())
    .then(data => {
      if (data.valid) {
        console.log("✅ Usuario autenticado:", data.usuario);
      } else {
        console.log("⛔ Token inválido o expirado.");
        navigate("/login"); // Redirigir si el token no es válido
      }
    })
    .catch(error => {
      console.error("❌ Error al obtener la sesión:", error);
    });
}, []);


document.addEventListener("keydown", function(event) {
  if (event.key === "Escape") {
    console.log("Se presionó Escape");
   setContenido(false)
    
  }
});


  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const cambiarImagen = (e) => {
    SetInpuntImagen(e.target.files[0]);
  };

  async function subirContenido() {
    try {
      const formData = new FormData();
      formData.append("titulo", titulo); // Agregar el título
      formData.append("descripcion", descripcion); // Agregar la descripción
      if (file) {
        formData.append("file", file); // Agregar el archivo si está presente
      }
     

      // Realizar la solicitud POST con FormData
      const respuesta = await fetch(
        "https://disomex.onrender.com/api/imagenes-insertar",
        {
          method: "POST",
          body: formData, // FormData contiene todos los datos y el archivo
        }
      );
      if (respuesta.ok) {
        console.log("Contenido agregado con exito");
        window.location.reload();
      }
    } catch (error) {
      console.error("Error al enviar los datos:", error);
    }
  }

  async function cambiarContenido(id) {
    try {
      const formData = new FormData();
      formData.append("id", id); // Agregar el título
      formData.append("titulo", inputTitulo); // Agregar el título
      formData.append("descripcion", inputDescripcion); // Agregar la descripción
      formData.append("file", inputImagen); // Agregar el archivo

      // Realizar la solicitud POST con FormData
      const respuesta = await fetch(
        "https://disomex.onrender.com/api/imagenes-editar",
        {
          method: "POST",
          body: formData, // FormData contiene todos los datos y el archivo
        }
      );
      if (respuesta.ok) {
        console.log("Contenido agregado con exito");
        navigate(0);
      }
    } catch (error) {
      console.error("Error al enviar los datos:", error);
    }
  }

  async function eliminarContenido(id) {
    try {
      const respuesta = await fetch(
        "https://disomex.onrender.com/api/imagenes-eliminar",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Indicamos que el contenido es JSON
          },
          body: JSON.stringify({
            id, // Enviamos el id como JSON
          }),
        }
      );

      if (respuesta.ok) {
        console.log("Contenido eliminado con éxito");
        navigate(0);
      } else {
        console.error("Error al eliminar el contenido:", respuesta.statusText);
      }
    } catch (error) {
      console.error("Error al enviar los datos:", error);
    }
  }



  useEffect(() => {
    const enviarDatos = async () => {
      try {
        const respuesta = await fetch(
          "https://disomex.onrender.com/api/obtener-imagen",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({}),
          }
        );
        // Manejar la respuesta
        const data = await respuesta.json();
        // Verifica si hay datos y asigna el array a 'datos'
        if (data.datos && Array.isArray(data.datos)) {
          setDatos(data.datos); // Ahora accedemos a 'data.datos'
        } else {
          console.error("La respuesta no contiene un array 'datos':", data);
        }
      } catch (error) {
        console.error("Error al enviar los datos:", error);
      }
    };
  
    enviarDatos();
  }, []);
  

  

  // Función para abrir el modal
  const abrirModal = (item) => {
    setModalData(item); // Guarda los datos del elemento clicado
    SetInpuntDescripcion(item.descripcion || "");
    SetInpuntTitulo(item.titulo || "");
    SetInpuntImagen(`data:image/jpeg;base64,${item.imagen}` || null);

    
  };

  // Función para cerrar el modal
  const cerrarModal = () => {
    setModalData(null);
  };

 

  return (
    <div className="p-6">
      {contenido && (
        <div className="flex justify-center fixed inset-0 bg-black bg-opacity-70 items-center z-50">
          <div className="bg-white p-6 rounded-lg shadow-lg max-w-[90%] max-h-[90%]">
            <form action="">
              <div className="flex flex-col">
                <label htmlFor="">Titulo Imagen</label>
                <input
                  type="text"
                  onChange={(e) => {
                    setTitulo(e.target.value);
                  }}
                  className="border border-black mb-4"
                />
              </div>
              <div className="flex flex-col">
                <label htmlFor="">Descripcion Imagen</label>
                <textarea
                  onChange={(e) => {
                    setDescripcion(e.target.value);
                  }}
                  className="border border-black mb-4 h-[100px]"
                />

                <input
                  type="file"
                  className="mb-2"
                  onChange={handleFileChange}
                />
              </div>
              <button
                onClick={() => {
                  setContenido(false);
                }}
                className="absolute font-bold top-4 right-4 text-white text-3xl bg-black p-2 rounded-full sm:text-xl"
              >
                ✕
              </button>
              <div className="flex justify-center">
                <button
                  onClick={(e) =>{
                    e.preventDefault()
                    subirContenido()
                  }}
                  className="bg-yellow-300 p-2 px-4"
                >
                  Enviar
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Filtros con resaltado del servicio seleccionado */}
      <div className="flex flex-col items-center justify-around text-lg font-semibold mb-6 sm:flex-row ">
        {[
          "Todos",
          "Desarrollo Software",
          "Desarrollo Web",
          "Diseño Grafico",
          "Gestion De Eventos",
          "Redes Sociales",
        ].map((categoria) => (
          <p
            key={categoria}
            onClick={() => setFiltro(categoria)}
            className={`cursor-pointer ${
              filtro === categoria
                ? " font-bold border-b-[3.5px] border-black"
                : "text-black"
            }`}
          >
            {categoria}
          </p>
        ))}
      </div>
      <div className="flex justify-center">
        <button
          onClick={(e) => {
            setContenido(true);
          }}
          className="p-2 bg-yellow-300"
        >
          Agregar Contenido
        </button>
      </div>

      <div className="flex flex-wrap justify-between p-6 px-0 mb-2 sm:px-12">
    {datos.map((item) => (
      <div
        key={item.id}
        className="containers relative w-[450px] h-[250px] group mx-auto mb-6 sm:w-[400px] hover:cursor-pointer"
        onClick={() => abrirModal(item)}
      >
        <img
          src={`data:image/jpeg;base64,${item.imagen}`} // Mostrar la imagen usando Base64
          alt={item.titulo}
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 flex flex-col justify-center items-center bg-black bg-opacity-50 text-white text-center p-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <h1 className="text-xl font-bold">{item.titulo}</h1>
          <p className="text-sm">{item.descripcion}</p>
        </div>
      </div>
    ))}
  

        {modalData && (
          <div
           key={modalData.id}
            className="fixed inset-0 bg-black bg-opacity-70 flex justify-center items-center z-50"
          >
            
            <div className="bg-white p-6 flex flex-col items-center rounded-lg shadow-lg max-w-[90%] max-h-[90%]">
              <button
                onClick={cerrarModal}
                className="absolute font-bold top-4 right-4 text-white text-3xl bg-black p-2 rounded-full sm:text-xl"
              >
                ✕
              </button>
              <img
                src={inputImagen}
                alt={modalData.titulo}
                className="h-[200px] w-[400px] object-contain mb-4"
              />
              <input type="file" onChange={cambiarImagen} />
              < input className="text-xl font-bold text-center mt-4 mb-4" value={inputTitulo} onChange={(e) =>{
                SetInpuntTitulo(e.target.value)
              }} />              
               <textarea type="text" className="w-[350px] h-[150px] text-xl mb-4 border-2 border-black px-2"  value={inputDescripcion} onChange={(e) =>{
                SetInpuntDescripcion(e.target.value)
              }}/>

              <div className="flex justify-center">
                <button
                  className="p-2 mr-4 bg-red-500 text-white mt-4"
                  onClick={() => eliminarContenido(modalData.id)}
                >
                  Eliminar
                </button>
                <button className="p-2 mt-4 mr-4 text-white bg-green-500" onClick={() => cambiarContenido(modalData.id)}>Guardar</button>
                <button className="p-2 mt-4 text-white bg-blue-400" onClick={() => cerrarModal()}>Cancelar</button>

                
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProyectosAdmin;
